import React, { useState } from "react";
import "./ErrorView.css";
import { EFaultedReason } from "./Model/ModuleState";
import MtiButton from "./components/Buttons/MtiButton";
import ToolsApi from "./api/ToolsApi";

type Props = {
  title: string;
  message: string;
  detail: any;
  reason: EFaultedReason;
};

export default function ErrorView({ title, message, detail, reason }: Props) {
  const [isErrorAcknowledged, setIsErrorAcknowledged] = useState(false);
  return (
    <div className="app-error-container">
      <span className="error-title">{title}</span>
      <pre style={{whiteSpace: "pre-wrap"}} className="error-message">{message}</pre>
      {detail != null && (
        <div className="error-exception">
          <div className="error-exception-text">
            <span>{detail} </span>
          </div>
          <svg
            className="error-exception-icon"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 24C7 14.6112 14.6112 7 24 7C33.3888 7 41 14.6112 41 24C41 33.3888 33.3888 41 24 41C14.6112 41 7 33.3888 7 24ZM26.4286 28.0475H21.5714L21.5714 13.4761H26.4286L26.4286 28.0475ZM21.5714 34.5238H26.4285V29.6666H21.5714V34.5238Z"
              fill="#8C2228"
            />
          </svg>
        </div>
      )}
      {reason === EFaultedReason.DiagnosticFailed && !isErrorAcknowledged && (
        <div>
          <MtiButton
            size="large"
            style={{ margin: "10px 0px 0px 0px", float: "right" }}
            onClick={() => {
              ToolsApi.ignoreDiagnosticError(false);
              setIsErrorAcknowledged(true);
            }}
          >
            OK
          </MtiButton>
          <MtiButton
            size="large"
            variant="secondary"
            style={{ margin: "10px 10px 0px 0px", float: "right" }}
            onClick={() => ToolsApi.ignoreDiagnosticError(true)}
          >
            Ignore
          </MtiButton>
        </div>
      )}
    </div>
  );
}
